import { useState } from "react";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import Network from "../../utils/Network";
import { Urls } from "../../utils/Constants";

export default function Lic() {
  const [errors, setErrors] = useState({});
  const [licNo, setLicNo] = useState("");
  const [email, setEmail] = useState("");
  const [dob, setDob] = useState("");
  const [mob, setMob] = useState("");
  const [ad1, setAd1] = useState("");
  const [ad2, setAd2] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [billData, setBillData] = useState("");
  const [amount, setAmount] = useState("");

  const fetchBill = async (event) => {
        event.preventDefault();
        const newErrors = errorHandling('fetchBill');
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            let formData = new FormData();
            const localStorageDataStr = localStorage.getItem('token');
            const item = JSON.parse(localStorageDataStr);
            formData.append("api_token", item.token);
            formData.append("dateofbirth", dob);
            formData.append("licnumber", licNo);
            formData.append("email", email);
            formData.append("mobile", mob);
        try {
            const response = await Network.post(Urls.baseUrlPostLogin + '/lic-bill-fetch',formData);
            console.log(response);
            // if(response?.data){
                //setAd1(response.data.ad1);
                //setAd2(response.data.ad2);
                //setAccountHolderName(response.data.accountHolderName);
                //setDueDate(response.data.dueDate);
                //setBillData(response.data.BillData);
            // }else{
              // const apiErrors = {apiError : response.data.message};
          // setErrors(apiErrors);
            // }
        } catch (err) {
            console.log('error', err);
        }
      }
  }
  const payBill = async () => {
        const newErrors = errorHandling('payBill');
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            let formData = new FormData();
            const localStorageDataStr = localStorage.getItem('token');
            const item = JSON.parse(localStorageDataStr);
            formData.append("api_token", item.token);
            formData.append("billerId", licNo);
            // formData.append("ad1", dob);
            // formData.append("ad2", email);
            // formData.append("accountHolderName", mob);
            // formData.append("dueDate", mob);
            // formData.append("BillData", mob);
            // formData.append("bbps_pin", 1234);
            // formData.append("amount", amount);
        try {
            const response = await Network.post(Urls.baseUrlPostLogin + '/lic-bill-fetch',formData);
            console.log(response);
            // if(response?.data){
            
            // }else{
              // const apiErrors = {apiError : response.data.message};
          // setErrors(apiErrors);
            // }
        } catch (err) {
            console.log('error', err);
        }
      }
  }

  const errorHandling = (type) => {
        const errors = {};
        if (type === 'fetchBill') {
            if (!licNo.trim()) {
            errors.licNo = 'Lic Number is required';
            }else if (!email.trim()) {
            errors.email = 'Email is required';
            }else if (!dob.trim()) {
            errors.dob = 'Date of birth is required';
            }else if(!mob.trim()){
            errors.mob = 'Mobile is required';
            }
        }else if(type === 'payBill'){
            if (!licNo.trim()) {
            errors.licNo = 'Lic Number is required';
            }else if (!email.trim()) {
            errors.email = 'Email is required';
            }else if (!dob.trim()) {
            errors.dob = 'Date of birth is required';
            }else if(!mob.trim()){
            errors.mob = 'Mobile is required';
            }
        }
        return errors;
  };

  return (
    <>
      <Header />
      <div className="adminuiux-wrap">
        <Sidebar />
        <main
          className="adminuiux-content has-sidebar"
        >
          {/*mt-4*/}
          <div className="container " id="main-content">
            <div className="row align-items-center">
            </div>
            {/* dashboard inner */}
            <div className="midde_cont">
              <div className="container-fluid">
                <div className="row column_title">
                  <div className="col-md-12">
                    <div className="page_title d-sm-flex">
                      <h2>Bill Pay</h2>
                    </div>
                  </div>
                </div>
                <div className="row match-height">
                  <div className="col-md-5 col-12">
                    <div className="card">
                      <div className="card-content">
                        <div className="card-body">
                          <div className="form-body">
                            <div className="col-md-12">
                              <form id="licfet" method="POST" onSubmit={fetchBill}>
                                <div className="form-group">
                                  <label>Lic Number</label>
                                  <input
                                    type="text"
                                    name="licnumber"
                                    className="form-control"
                                    defaultValue=""
                                    placeholder="Lic Number"
                                    required=""
                                    value={licNo}
                                    onChange={(e) => { setLicNo(e.target.value) }}
                                  />
                                {errors.licNo && (
                                    <span className="error-message">
                                        {errors.licNo}
                                    </span>
                                )}
                                </div>
                                <div className="form-group">
                                  <label>Email Id</label>
                                  <input
                                    type="text"
                                    name="email"
                                    className="form-control"
                                    defaultValue=""
                                    placeholder="Email Id"
                                    required=""
                                    value={email}
                                    onChange={(e) => { setEmail(e.target.value) }}
                                  />
                                {errors.email && (
                                    <span className="error-message">
                                        {errors.email}
                                    </span>
                                )}
                                </div>
                                <div className="form-group">
                                  <label>Date Of Birth</label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    name="dateofbirth"
                                    defaultValue=""
                                    placeholder="dd/mm/yyyy"
                                    required=""
                                    value={dob}
                                    onChange={(e) => setDob(e.target.value)}
                                  />
                                {errors.dob && (
                                    <span className="error-message">
                                        {errors.dob}
                                    </span>
                                )}
                                </div>
                                <div className="form-group">
                                  <label>Mobile</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="mobile"
                                    placeholder="Mobile"
                                    required=""
                                    value={mob}
                                    onChange={(e) => setMob(e.target.value)}
                                  />
                                {errors.mob && (
                                    <span className="error-message">
                                        {errors.mob}
                                    </span>
                                )}
                                </div>
                                {errors.apiError && (
                                    <span className="error-message">
                                        {errors.apiError}
                                    </span>
                                )}
                                <div className="form-group">
                                  <button
                                    id="fetch_btn"
                                    className="btn btn-primary btn-sm tx-13 mr-1 mb-1 waves-effect waves-light"
                                    onClick={fetchBill}
                                  >
                                    Fetch Bill
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            {/* Modal */}
          </div>
        </main>
      </div>
    </>
  );
}